import request from '@/CommonDP/utils/request';
// 系统文件管理
export default {
  // 列表
  raiseCapitalQueryList(standardType, enterpriseId) {
    return request.get(
      `/system/raiseCapital/queryList?standardType=${standardType}&enterpriseId=${enterpriseId}`
    );
  },
  // 修改
  raiseCapitalUpdate(params) {
    return request.post('/system/raiseCapital/update', params);
  },
  raiseCapitalDownload(fileID) {
    // 下载
    return request({
      url: `/system/raiseCapital/download/${fileID}`,
      method: 'get',
      responseType: 'blob'
    });
  },
  // 详情
  raiseCapitalQueryInfo(fileID) {
    return request.get(`/system/raiseCapital/queryInfo/${fileID}`);
  },
  raiseCapitalUpload(data) {
    return request.post('/system/raiseCapital/upload', data, {
      timeout: 0
    });
  }
};
